module.exports = __webpack_public_path__ + "static/img/icon-01.626e90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/value/icon-01.png
// module id = Um0D
// module chunks = 1